import React, { ChangeEvent } from 'react';
import { StepProps } from '../../../types';

const LeagueInfoStep: React.FC<StepProps> = ({ formData, updateFormData }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  return (
    <div className="step-content">
      <div className="step-section">
        <h3 className="step-section-title">Contact Information</h3>
        <p className="step-section-description">
          We'll use this information to contact you about your order.
        </p>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">League/Organization Name *</label>
            <input
              type="text"
              name="leagueName"
              className="form-input"
              value={formData.leagueName}
              onChange={handleChange}
              required
              placeholder="e.g., Kerrville Youth Baseball"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Contact Name *</label>
            <input
              type="text"
              name="contactName"
              className="form-input"
              value={formData.contactName}
              onChange={handleChange}
              required
              placeholder="Your full name"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Email *</label>
            <input
              type="email"
              name="contactEmail"
              className="form-input"
              value={formData.contactEmail}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Phone</label>
            <input
              type="tel"
              name="contactPhone"
              className="form-input"
              value={formData.contactPhone}
              onChange={handleChange}
              placeholder="(555) 555-5555"
            />
          </div>
        </div>
      </div>

      <div className="step-section">
        <h3 className="step-section-title">Order Details</h3>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Season/Event</label>
            <input
              type="text"
              name="season"
              className="form-input"
              value={formData.season}
              onChange={handleChange}
              placeholder="e.g., Spring 2026, Fall League"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Requested Delivery Date</label>
            <input
              type="date"
              name="requestedDate"
              className="form-input"
              value={formData.requestedDate}
              onChange={handleChange}
            />
            <span className="form-hint">When do you need the uniforms?</span>
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Additional Notes</label>
          <textarea
            name="notes"
            className="form-input"
            value={formData.notes}
            onChange={handleChange}
            rows={4}
            placeholder="Any special requirements, deadlines, or information we should know..."
          />
        </div>
      </div>
    </div>
  );
};

export default LeagueInfoStep;
